import React, { useEffect } from 'react'
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './styles.css';

const SizeWhiteList = ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"];
const FontWhiteList = [
    'Andale-Mono', 'Arial', 'Arial-Black', 'Book-Antiqua', 'Comic-Sans-MS', 
    'Courier-New', 'Georgia', 'Helvetica', 'Impact', 'Symbol', 'Tahoma', 
    'Terminal', 'Times-New-Roman', 'Trebuchet-MS', 'Verdana'
];

//Custom sizes
const Size = Quill.import('attributors/style/size');
Size.whitelist = SizeWhiteList;
Quill.register(Size, true);

// Custom Font
const Font = Quill.import('formats/font');
Font.whitelist = FontWhiteList;
Quill.register(Font, true);

function EditorTool({
    value,
    setValue,
    page
}) {
    const modulesNotitifation = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'size': SizeWhiteList }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block'],
            [{ 'script': 'sub'}, { 'script': 'super' }],
            [{ 'align': [] }],
            ['clean']
        ]
    }
    const modulesProduct = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }, { 'font': FontWhiteList }],
            [{ 'size': SizeWhiteList }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block'],
            [{ 'script': 'sub'}, { 'script': 'super' }],
            [{'list': 'ordered'}, {'list': 'bullet'}, { 'list': 'check' }, {'indent': '-1'}, {'indent': '+1'}],
            [{ 'direction': 'rtl' }], 
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            ['link', 'image', 'video'],
            ['clean']
        ]
    }

    useEffect(() => {
        if (value) {
            setValue(value);
        }
    }, [value]);

    return (
        <ReactQuill 
            theme="snow" 
            modules={page === "notifications" ? modulesNotitifation : modulesProduct}
            value={value} 
            onChange={(e) => setValue(e)}
            style={{"border": "1px solid #ccc", "borderRadius": "4px"}}
        />
    )
}

export default EditorTool